import { defineComponent, h, ref } from 'vue'
import { Form } from 'ant-design-vue'

/**
 * 兼容 Vue2 时代的 a-form-model / a-form-model-item 用法，映射到 a-form / a-form-item。
 * 目标是降低一次性全量改造成本，后续可逐步替换为官方写法。
 */
export const FormModel = defineComponent({
  name: 'AFormModel',
  inheritAttrs: false,
  props: {
    model: { type: Object, default: () => ({}) },
    rules: { type: Object, default: () => ({}) },
    layout: { type: String, default: undefined },
    labelCol: { type: Object, default: undefined },
    wrapperCol: { type: Object, default: undefined },
  },
  setup(props, { slots, expose, attrs }) {
    const formRef = ref()

    const validate = (cb) => {
      if (!formRef.value || !formRef.value.validate) {
        cb && cb(false)
        return Promise.reject(new Error('Form not ready'))
      }
      return formRef.value
        .validate()
        .then(() => {
          cb && cb(true)
          return true
        })
        .catch((err) => {
          cb && cb(false, err)
          return false
        })
    }

    const resetFields = () => formRef.value?.resetFields?.()
    const clearValidate = (names) => formRef.value?.clearValidate?.(names)

    expose({
      validate,
      resetFields,
      clearValidate,
      formRef,
    })

    return () =>
      h(
        Form,
        {
          ref: formRef,
          model: props.model,
          rules: props.rules,
          layout: props.layout,
          labelCol: props.labelCol,
          wrapperCol: props.wrapperCol,
          ...attrs,
        },
        slots
      )
  },
})

export const FormModelItem = defineComponent({
  name: 'AFormModelItem',
  inheritAttrs: false,
  props: {
    prop: { type: [String, Array], default: undefined },
    label: { type: String, default: undefined },
    labelCol: { type: Object, default: undefined },
    wrapperCol: { type: Object, default: undefined },
    rules: { type: [Object, Array], default: undefined },
    hasFeedback: { type: Boolean, default: false },
    extra: { type: String, default: undefined },
  },
  setup(props, { slots, attrs }) {
    return () =>
      h(
        Form.Item,
        {
          name: props.prop,
          label: props.label,
          labelCol: props.labelCol,
          wrapperCol: props.wrapperCol,
          rules: props.rules,
          hasFeedback: props.hasFeedback,
          extra: props.extra,
          ...attrs,
        },
        slots
      )
  },
})

export function setupAntdCompat(app) {
  app.component('a-form-model', FormModel)
  app.component('a-form-model-item', FormModelItem)
}















